import React, { useEffect, useState } from "react";
import AdminPanelGeneralHeading from "../components/AdminPanelGeneralHeading";
import { useNavigate, useParams } from "react-router-dom";
import ErrorAlert from "../components/ErrorAlert";
import SuccessAlert from "../components/SuccessAlert";

export default function UpdatePlace() {
  const { placeCity } = useParams();
  const navigate = useNavigate();

  // State Handling
  const [placesData, setPlacesData] = useState({
    place_img: "",
    place_country: "",
    place_city: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  // Upload Image Handling
  const placeImgHandler = (e) => {
    const imgFile = e.target.files[0];
    if (imgFile) {
      const imgReader = new FileReader();
      imgReader.readAsDataURL(imgFile);
      imgReader.onloadend = () => {
        setPlacesData({
          ...placesData,
          place_img: imgReader.result,
        });
      };
      imgReader.onerror = (error) => {
        console.log(error);
      };
    }
  };

  //   Get Place's Data
  const singlePlace = async () => {
    const response = await fetch(`https://hotelbnb-backend.onrender.com/place/${placeCity}`);
    const result = await response.json();

    if (response.ok) {
      setPlacesData(result);
    }
  };

  // Form Submission To Update Place In DataBase
  const updatePlacesSubmitHandler = async (e) => {
    e.preventDefault();
    window.scrollTo(0,0);
    setLoading(true);

    try{
      const response = await fetch(
        `https://hotelbnb-backend.onrender.com/edit-place/${placeCity}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(placesData),
        }
      );
      const result = await response.json();
  
      if (response.ok) {
        setSuccess("Place Updated!");
  
        setTimeout(() => {
          navigate("/admin/add-places");
        }, 1000);
      } else if (!response.ok) {
        setError("Update Failed! Please Try Again");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    singlePlace();
  }, []);

  if (loading)
    return (
      <div className="d-flex flex-column gap-2 justify-content-center align-items-center loading-state">
        <div className="spinner-grow" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>Updating Place</p>
      </div>
    );

  if (!loading)
  return (
    <>
      {/* Showing Alert based on http request response Start */}
      {success && <SuccessAlert successMsg={success} />}
      {error && <ErrorAlert errorMsg={error} />}
      {/* Showing Alert based on http request response End */}

      {/* Update Place Heading Start */}
      <AdminPanelGeneralHeading text="Update Place" />
      {/*Update Place Heading End */}

      {/* Update Place Form Start */}
      <div className="col-12 add-places-form-cover signup-form-cover">
        <form className="p-0" onSubmit={updatePlacesSubmitHandler}>
          {/* Row 1 */}
          <div className="d-flex justify-content-center align-items-center">
            <div className="p-0 m-0 upload-place-hotel-pic-cover upload-profile-pic-cover d-flex justify-content-center align-items-center position-relative">
              <i className="fa-solid fa-camera"></i>
              <input
                type="file"
                name="place_img"
                className="profile-pic-input"
                onChange={placeImgHandler}
              />
              {placesData.place_img ? (
                <img
                  src={placesData.place_img}
                  alt="place-img"
                  className="img-fluid"
                />
              ) : (
                ""
              )}
            </div>
          </div>

          {/* Row 2 */}
          <div className="d-flex gap-3 signup-form-row">
            <div className="col p-0 signup-col">
              <input
                type="text"
                name="place_country"
                required
                placeholder="Country (ex: Canada)"
                className="form-control text-capitalize"
                value={placesData.place_country}
                onChange={(e) => {
                  setPlacesData({
                    ...placesData,
                    place_country: e.target.value.toLowerCase(),
                  });
                }}
              />
            </div>
            <div className="col p-0 signup-col">
              <input
                type="text"
                name="place_city"
                placeholder="City (ex: Toronto)"
                required
                className="form-control text-capitalize"
                value={placesData.place_city}
                onChange={(e) => {
                  setPlacesData({
                    ...placesData,
                    place_city: e.target.value.toLowerCase(),
                  });
                }}
              />
            </div>
          </div>

          {/* Submit Btn */}
          <button
            type="submit"
            className="btn custom-btn signup-btn rounded-pill d-block mx-auto"
          >
            Update Place
          </button>
        </form>
      </div>
      {/* Update Place Form End */}
    </>
  );
}
